/* Component Dependencies */
var inThisSectionTemplate = require('templates/inThisSection.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'inThisSection',
  template: {
    'inThisSection': inThisSectionTemplate
  }
});
